var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"products-page"}},[_c('AppHero',{attrs:{"heading":'Our Products'}}),_c('OurProducts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }